// The default company entity's id from a company-entities list (the row flagged
// is_default — e.g. "Amplifybio LLC"). Returns "" when there is no default or the
// list is empty. Single source of truth for the intake form's Company Entity
// preselect: used on mount, by the open/reload backstop effect, and by
// resetContract so a fresh or reopened form always preselects the default rather
// than "Select…" (R2 regression fix, 2026-07-20).
export function defaultEntityId(
  entities: Array<{ id: string; is_default?: boolean }> | null | undefined
): string {
  return (entities || []).find((e) => e.is_default)?.id || "";
}
